import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';

const Rules = () => {
  const { user } = useAuth();
  const [rules, setRules] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [editText, setEditText] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchRules();
  }, []);

  const fetchRules = async () => {
    try {
      const response = await api.get('/rules');
      setRules(response.data.content || '');
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching rules:', error);
      setIsLoading(false);
    }
  };

  const handleEdit = () => {
    setEditText(rules);
    setIsEditing(true);
  };

  const handleSave = async () => {
    try {
      await api.post('/rules', { content: editText });
      setRules(editText);
      setIsEditing(false);
      alert('Rules updated successfully!');
    } catch (error) {
      alert('Failed to update rules');
    }
  };

  const handleCancel = () => {
    setIsEditing(false);
    setEditText('');
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-dark text-white flex items-center justify-center">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-dark text-white p-6">
      <div className="max-w-4xl mx-auto">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold">Contest Rules</h1>
          {user?.role === 'admin' && !isEditing && (
            <button
              onClick={handleEdit}
              className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-green-600 transition"
            >
              Edit Rules
            </button>
          )}
        </div>

        {isEditing ? (
          <div>
            <textarea
              value={editText}
              onChange={(e) => setEditText(e.target.value)}
              className="w-full h-96 bg-dark-secondary text-white p-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
              placeholder="Enter contest rules here..."
            />
            <div className="flex gap-3 mt-4">
              <button
                onClick={handleSave}
                className="px-6 py-2 bg-primary text-white rounded-lg hover:bg-green-600 transition"
              >
                Save
              </button>
              <button
                onClick={handleCancel}
                className="px-6 py-2 bg-dark-secondary text-white rounded-lg hover:bg-gray-700 transition"
              >
                Cancel
              </button>
            </div>
          </div>
        ) : (
          <div className="bg-dark-secondary rounded-lg p-6">
            {rules ? (
              <pre className="whitespace-pre-wrap text-gray-300 font-sans">
                {rules}
              </pre>
            ) : (
              <p className="text-gray-400 italic">No rules have been set yet.</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Rules;
